module.exports = __webpack_public_path__ + "app-static/img/null.ea42c5de.png";